'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setHeaderDropdownVisible = exports.isHeaderDropdownVisible = exports.SET_HEADER_DROPDOWN_VISIBLE = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _reselect = require('reselect');

var _constants = require('redux-persist/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var SET_HEADER_DROPDOWN_VISIBLE = exports.SET_HEADER_DROPDOWN_VISIBLE = 'SET_HEADER_DROPDOWN_VISIBLE';

/* reducer */
var DEFAULT_STATE = {
    headerDropdownVisible: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _constants.REHYDRATE:
            if (Object.prototype.hasOwnProperty.call(action.payload, 'persist') && Object.prototype.hasOwnProperty.call(action.payload.persist, 'headerSearchDropdown')) {
                var incoming = action.payload.persist.headerSearchDropdown;
                return (0, _extends3.default)({}, state, incoming);
            }
            return state;
        case SET_HEADER_DROPDOWN_VISIBLE:
            return (0, _extends3.default)({}, state, {
                headerDropdownVisible: action.payload
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.persist.headerSearchDropdown;
};

var isHeaderDropdownVisible = exports.isHeaderDropdownVisible = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.headerDropdownVisible;
});

/* ACTION CREATORS */
var setHeaderDropdownVisible = exports.setHeaderDropdownVisible = function setHeaderDropdownVisible() {
    var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return {
        payload: show,
        type: SET_HEADER_DROPDOWN_VISIBLE
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/headerSearchDropdown.js
// module id = HxLY
// module chunks = 57